import { render, staticRenderFns } from "./NgCheck.vue?vue&type=template&id=3062515a"
import script from "./NgCheck.vue?vue&type=script&lang=js"
export * from "./NgCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports